import { UUIDv4 } from 'uuid-v4-validator'
import z from 'zod'
import { CountriesListValues } from '../../interfaces & enums/country'
import { LanguageEnumValues } from '../../interfaces & enums/language'
import { UserSchema } from './definitions'

export const USER_SCHEMA = z.object<Record<keyof typeof UserSchema, any>>({
  firstName: z.string().trim().min(2),
  lastName: z.string().trim().min(2),
  email: z
    .string()
    .trim()
    .refine((val) => /@.*\./.test(val)),
  phone: z
    .string()
    .trim()
    .regex(/^\+?[1-9]\d{1,14}$/)
    .min(6)
    .transform((str) => str.trim().replaceAll('+', ''))
    .refine((str) => !isNaN(parseFloat(str)))
    //if number is passed, convert to string
    .or(z.number().transform((passedNum) => passedNum.toString())),
  language: z
    .string()
    .trim()
    .transform((str) => str.toLocaleLowerCase())
    .refine((val) => Object.values(LanguageEnumValues).includes(val as LanguageEnumValues)),
  leadStatus: z
    .string()
    .trim()
    .transform((val) => val.trim()),
  country: z
    .string()
    .trim()
    .transform((str) => str.toLocaleUpperCase())
    .refine((val) => Object.values(CountriesListValues).includes(val as CountriesListValues)),
  description: z
    .string()
    .trim()
    .optional()
    .transform((str) => (str?.trim() === '' ? 'Generated' : str))
    .refine((val) => (val === undefined ? true : !!val.length)),
  agentId: z
    .string()
    .refine((val) => (val === '' ? true : UUIDv4.validate(val)))
    .optional()
    .refine((val) => (val === undefined ? true : !!val.length)),
  account: z
    .string()
    .refine((val) => !Number.isNaN(parseInt(val)))
    .optional()
    .or(z.number().refine((passedNum) => passedNum.toString()))
    .refine((val) => (val === undefined ? true : typeof val === 'string' ? !!val.length : true)),
  tag: z
    .string()
    .trim()
    .optional()
    .refine((val) => (val === undefined ? true : !!val.length)),
})
